import swal from "sweetalert2";

export async function confirmCompletionOnLeave() {
	try {
		const result = await swal.fire({
			title: "Complete Now?",
			html: "This report has no outstanding errors. Do you want to complete it before leaving?",
			showCloseButton: true,
			type: "info",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Complete Now",
			cancelButtonText: "Leave Without Completing"
		});

		if(!result.dismiss) {
			return { action: "complete" };
		}

		if(result.dismiss === swal.DismissReason.cancel) {
			return { action: "leave" };
		}

		return { action: "dismiss" };
	}
	catch(error) {
		return { action: "dismiss" };
	}
}
